import React from 'react';
import ReactDOM from 'react-dom';

import '../reset.scss';
import './embed.scss';

import Store from 'store';

import makeGameTips from './gametips';
import { getProfilePath } from 'common';
import { dataLoaded, renderCollection, renderProfile, renderRapport } from './cache';
import Paperdoll from 'components/Paperdoll';
import SkillView, { CompactSkillView } from 'components/SkillView';
import CardView from 'components/CardView';
import RapportNpc from 'components/RapportNpc';
import CollectionView from 'components/CollectionView';

const Error = ({ text }) => <div className="lap-error">{text}</div>;

function EmbedPicker({ type, href }) {
  const embed = Store.useEmbed();
  if (embed.type !== type && (embed.type !== 'skills' || type !== 'compactskills')) return <div className="lap-error">Embed type mismatch!</div>;
  if (embed.type === 'equipment') return <Paperdoll embed={embed}/>;
  if (embed.type === 'skills') return type === 'compactskills' ? <CompactSkillView embed={embed}/> : <SkillView embed={embed}/>;
  if (embed.type === 'cards') return <CardView embed={embed}/>;
  return <div className="lap-error">Unknown embed type!</div>;
}

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".la-embed");
  for (const el of elements) {
    const profile = el.getAttribute("data-la-profile");
    if (profile?.match(/^\w{8,9}$/)) {
      const id = el.getAttribute("data-la-id");
      const type = el.getAttribute("data-la-type");
      let href = getProfilePath(id);
      if (id) href += '#' + encodeURIComponent(id);
      renderProfile(el, profile, id, (
        <div className="laplanner-wrapper">
          <EmbedPicker type={type} href={href}/>
        </div>
      )).catch(() => ReactDOM.render(<Error text="Failed to load profile"/>, el));
      //)).catch(e => ReactDOM.render(e.message, el));
    }
    const npc = el.getAttribute("data-la-npc");
    if (npc) {
      renderRapport(el, npc, (
        <div className="laplanner-wrapper">
          <RapportNpc id={npc}/>
        </div>
      )).catch(() => ReactDOM.render(<Error text="Failed to load NPC"/>, el));
    }
    const collection = el.getAttribute("data-la-collection");
    if (collection) {
      renderCollection(el, collection, (
        <div className="laplanner-wrapper">
          <CollectionView type={collection}/>
        </div>
      )).catch(() => ReactDOM.render(<Error text="Failed to load collection"/>, el));
    }
  }

  dataLoaded.then(() => {
    makeGameTips();
  });
});
